import MajorTag from './MajorTag';

export default MajorTag;
